/* eslint-disable default-case */
import {
  SettingsResponseDataParams,
  BillingSettingsResponseParams,
  BillingFieldsEnum,
} from '../queries/settings';
import { SupportedPaymentMethods, BillingRequredValues } from '../constants';

const hasPaymentMethod = (methods: string[], method: string) => Array.isArray(methods) && methods.includes(method);

type BillingKeyType = keyof typeof BillingFieldsEnum;
/* eslint-disable @typescript-eslint/naming-convention */
const BillingFieldsMap: {
  [key in BillingKeyType]: string
} = {
  first_name: 'billingFirstName',
  last_name: 'billingLastName',
  name: 'billingFullName',
  birthday: 'billingBirthday',
  document_number: 'billingDocumentNumber',
  document_type: 'billingDocumentType',
  tax_id: 'billingTaxId',
  address1: 'billingAddress',
  address2: 'billingAddress2',
  city: 'billingCity',
  state: 'billingState',
  country: 'billingCountry',
  zip: 'billingZip',
  company: 'billingCompany',
  email: 'billingEmail',
  phone: 'billingPhone',
  fax: 'billingFax',
};
/* eslint-enable @typescript-eslint/naming-convention */

const prepareBillingConfig = (billing: BillingSettingsResponseParams) => {
  const billingKeys = <BillingKeyType[]>Object.keys(billing);
  return billingKeys.reduce<Record<string, Record<string, boolean>>>((acc, el) => {
    acc[BillingFieldsMap[el]] = { required: (billing[el] === BillingRequredValues.MANDATORY) || false };
    return acc;
  }, {});
};

export const generatePaymentMethodsConfiguration = (settings: SettingsResponseDataParams) => ({
  ...(hasPaymentMethod(settings.paymentMethods, SupportedPaymentMethods.CARD) && { cards: {
    billingConfig: {
      ...(prepareBillingConfig(settings.billingAddressFields)),
    },
    // TODO: must be configurable
    contactInformationConfig: {
      firstName: { required: true },
      lastName: { required: true },
    },
  } }),
  ...(hasPaymentMethod(settings.paymentMethods, SupportedPaymentMethods.OXXO) && { oxxo: {} }),
  ...(hasPaymentMethod(settings.paymentMethods, SupportedPaymentMethods.AFFIRM) && { affirm: {} }),
  ...(hasPaymentMethod(settings.paymentMethods, SupportedPaymentMethods.APPLEPAY) && { apple_pay: {} }),
  ...(hasPaymentMethod(settings.paymentMethods, SupportedPaymentMethods.GOOGLEPAY) && { google_pay: {} }),
});
